import PropTypes from 'prop-types'
import React from 'react'
import { reduxForm, Field } from 'redux-form'
import { FormattedMessage } from 'react-intl'
import RichTextFormField from 'components/RichText/FormField'

export class AddChecklistItemForm extends React.Component {
  static propTypes = {
    id: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.string
    ]),
    boardId: PropTypes.number.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    onCancelClick: PropTypes.func.isRequired
  }

  render () {
    const { id, boardId, handleSubmit, onCancelClick } = this.props

    return (
      <form onSubmit={handleSubmit} style={{ width: '100%' }}>
        <Field
          name='name'
          component={RichTextFormField}
          props={{
            richTextEditorProps: {
              autoFocus: true,
              mentionBoardId: boardId,
              saveChanges: 'addChecklistItem-' + id,
              closeAfterSubmit: false,
              submitButton: <FormattedMessage id='ADD' />,
              onSubmit: () => handleSubmit(),
              onBlur: onCancelClick
            }
          }}
        />
      </form>
    )
  }
}

export default reduxForm()(AddChecklistItemForm)
